import { render, staticRenderFns } from "./Infocheck.vue?vue&type=template&id=8beecdc6&scoped=true"
import script from "./Infocheck.vue?vue&type=script&lang=js"
export * from "./Infocheck.vue?vue&type=script&lang=js"
import style0 from "./Infocheck.vue?vue&type=style&index=0&id=8beecdc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beecdc6",
  null
  
)

export default component.exports